import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { loadTranslation, loadLangList } from '../application_actions';
import { receiveKenLink, removeKenLink } from '../application_actions';

import DropdownMenu from './presentational/dropdown_menu.jsx';

class Login extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const getQueryStringParams = () => {
      return new URLSearchParams(this.props?.location?.search)
    }

    this.props.loadTranslation(getQueryStringParams().get('lang'));

    let KEN = undefined;
    if (getQueryStringParams().get('ken')) {
      KEN = getQueryStringParams().get('ken');
    }

    if (typeof(KEN) == "string" && /^\d{8}$/.test(KEN))
      this.props.receiveKenLink(KEN);
    else
      this.props.removeKenLink();

    this.props.loadLangList();
  }

  render() {
    return (
      <div className="login">
        <div className="background"/>
          <div className="menu">
            <div className="right-menu">
              <DropdownMenu
                title={this.props.i18n.strings?.Login?.chooseLanguage}
                options={this.props.i18n.availableLanguages}
                currentSelection={this.props.i18n.language}
                onSelectionChange={(lang) => this.props.loadTranslation(lang) }
              />
            </div>
          </div>
          <div className="main-view">
            <div className="container">
              <div className="logo"/>
              <div className="title">{this.props.i18n.strings?.Login?.title}</div>
              <a className="login-btn" href="/auth/login" >{this.props.i18n.strings?.Login?.SSOButton}</a>
            </div>
          </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ loadLangList, loadTranslation, receiveKenLink, removeKenLink }, dispatch);
}

function mapStateToProps( { i18n } ) {
  return { i18n };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
